import Modal from "react-modal/lib/components/Modal";
import { IndexHooks } from "./hook";
import "./style.css";
import "../../../../style/form-register.css";
import { BtnSubmit } from "../../../button/button-submit/button-submit";
import { BtnBack } from "../../../button/button-back";
import libForm from "../../../../util/libForm";
import Loading from "../../../loading";
import TextInput from "../../../inputs/text";
import SelectInput from "../../../inputs/select";
import HeaderRegister from "../../../header/register";
import MaskInput from "../../../inputs/mask";
import { BtnCustom } from "../../../button/button";
import { useState } from "react";
import ModalMain from "../../../modal";
import Form from "../../../../pages/register/collaborator-type/form";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import CheckboxInput from "../../../inputs/check";
import Switch from "@mui/material/Switch";

const permissionsFields = {
	cadastros: [
		{ label: "Cadastro da Empresa", id: "permissoes.cad_empresa" },
		{ label: "Cadastro de Clientes", id: "permissoes.cad_cliente" },
		{ label: "Cadastro de Colaboradores", id: "permissoes.cad_colaborador" },
		{ label: "Cadastro de Produtos", id: "permissoes.cad_produto" },
		{ label: "Cadastro de Fornecedores", id: "permissoes.cad_fornecedor" },
		{ label: "Cadastro Financeiro", id: "permissoes.cad_financeiro" },
		{ label: "Gerenciar Permissões", id: "permissoes.cad_permissao" },
	],
	Despesas_Receitas: [
		{ label: "Lançamento de Receitas", id: "permissoes.cad_conta_entrada" },
		{ label: "Lançamento de Despesas", id: "permissoes.cad_conta_saida" },
	],
	Fiscal_Boleto: [
		{ label: "Emissão Fiscal", id: "permissoes.fiscal" },
		{ label: "Boletos", id: "permissoes.boleto" },
	],
	Marketing: [{ label: "WhatsApp e Instagram", id: "permissoes.marketing" }],
	pdv: [
		{ label: "Cancelar Pré Venda", id: "permissoes.pdv_cancelar_pre_venda" },
		{ label: "Excluir Item", id: "permissoes.pdv_excluir_item" },
		{ label: "Salvar Vale", id: "permissoes.pdv_salvar_vale" },
	],
	relatorios: [
		{ label: "Movimentação financeira", id: "permissoes.mov_caixa" },
		{ label: "Relatórios", id: "permissoes.relatorios" },
	],
};

export const ModalRegisterCollaborator = () => {
	const {
		//hook form
		errors,
		isSubmitting,
		register,
		control,
		handleSubmit,
		handleOnSubmit,

		setValue,

		//Data
		citiesData,
		collaboratorTypeData,

		//variaveis de estado
		loading,
		loadingCities,
		cepIsSubmitting,

		valueTab,
		hasPermission,
		podeGerenciarPermissoes,
		editandoASiMesmo,

		//context
		isOpenModalRegisterCollaborator,
		brazilStates,

		//funções
		handleSelectedState,
		handleFetchAddress,
		handleChangeTab,
		// insertTypeClient,
		// reloadTypeClient,
		handleCloseModal,
		insertCollaboratorType,
		reloadCollaboratorTypeData,
	} = IndexHooks();

	//#region modal type collaborator
	const [options] = useState({ ident: "collaboratortype" });

	const handleOpenRegisterTypeCollaborator = (e) => {
		e.preventDefault();
		const event = new CustomEvent(options.ident);
		window.dispatchEvent(event);
	};

	const handleCloseModalTypeCollaborator = () => {
		reloadCollaboratorTypeData();
	};

	const campoLiberado = ({ id }) => !(editandoASiMesmo && id === "permissoes.cad_permissao");

	const handleToggleAll = (group, checked) => {
		const checkboxes = permissionsFields[group].filter(campoLiberado);
		checkboxes.forEach(({ id }) => {
			setValue(id, checked);
		});
	};

	const onReceiveEmailPassword = () => {};

	return (
		<>
			<Modal
				isOpen={isOpenModalRegisterCollaborator}
				onRequestClose={handleCloseModal}
				overlayClassName="modal-overlay-register"
				className="modal-content-form modal-resize"
				shouldCloseOnOverlayClick={false}
			>
				<div className="container-forms">
					<HeaderRegister
						title={"Colaborador"}
						subTitle={"Cadastro de Colaboradores"}
						handleCloseModal={handleCloseModal}
					/>
					{loading ? (
						<div className="flex h-full">
							<Loading mensagem="Carregando..." />
						</div>
					) : (
						<form className="form" action="" onSubmit={handleSubmit(handleOnSubmit)}>
							<TabContext value={valueTab} className="">
								<Box>
									<TabList onChange={handleChangeTab}>
										<Tab
											label="Colaborador"
											value="0"
											sx={{
												fontSize: "0.775rem",
											}}
										/>
										{podeGerenciarPermissoes && (
											<Tab
												label="Permissões do colaborador"
												value="1"
												sx={{
													fontSize: "0.775rem",
												}}
											/>
										)}
									</TabList>
								</Box>
								<main>
									<TabPanel value="0">
										<input id="id_funcionario" {...register("id_funcionario")} type="hidden" />
										<input id="data" {...register("data")} type="hidden" />

										<div className="row">
											<TextInput
												label="Nome"
												id="nome"
												placeholder=""
												register={register}
												errors={errors}
												onKeyDown={libForm.EnterTab}
												autoFocus={true}
												className="col-12 col-sm-8 col-lg-8 "
											/>

											<div className="check-box col-6 col-sm-6 col-lg-2 truncate gap-1">
												<input
													id="pessoafisica"
													type="checkbox"
													{...register("pessoafisica")}
													onKeyDown={(e) => libForm.EnterTab(e)}
												/>
												<label className="" htmlFor="pessoafisica">
													Pessoa Física
												</label>
											</div>

											<div className={`check-box col-6 col-sm-6 col-lg-2 justify-center`}>
												<div className="check-input">
													<input
														className={`${errors.ativo ? "error" : ""}`}
														id="ativo_collaborator"
														type="checkbox"
														{...register("ativo")}
														onKeyDown={(e) => libForm.EnterTab(e)}
													/>
													<label htmlFor="ativo_collaborator">Ativo</label>
												</div>
											</div>

											<MaskInput
												label="Cep"
												name="cep"
												control={control}
												errors={errors}
												format="#####-###"
												className="col-4 col-sm-4 col-lg-2"
												onKeyDown={libForm.EnterTab}
											/>

											<div className="col-8 d-flex align-items-center">
												<BtnCustom
													className="btn btn-sm btn-outline-primary btn-cep"
													onClick={(e) => handleFetchAddress()}
													onKeyDown={(e) => libForm.EnterTab(e)}
													text={cepIsSubmitting ? "Buscando..." : "Buscar endereço por CEP"}
												/>
											</div>

											<TextInput
												label="Endereço"
												id="rua"
												placeholder=""
												register={register}
												errors={errors}
												onKeyDown={libForm.EnterTab}
												className="col-12 col-sm-8 col-lg-5"
											/>
											<TextInput
												label="Número"
												id="numero"
												placeholder=""
												register={register}
												errors={errors}
												onKeyDown={libForm.EnterTab}
												className="col-4 col-sm-4 col-lg-2"
											/>
											<TextInput
												label="Complemento"
												id="complemento"
												placeholder=""
												register={register}
												errors={errors}
												onKeyDown={libForm.EnterTab}
												className="col-8 col-sm-6 col-lg-2"
											/>
											<TextInput
												label="Bairro"
												id="bairro"
												placeholder=""
												register={register}
												errors={errors}
												onKeyDown={libForm.EnterTab}
												className="col-12 col-sm-6 col-lg-3"
											/>
											<SelectInput
												label="Estado"
												id="uf"
												labelSelect="nome"
												control={control}
												errors={errors}
												data={brazilStates}
												setValue={setValue}
												onKeyDown={libForm.EnterTab}
												handleSelect={handleSelectedState}
												loading={loadingCities}
												className="col-12 col-sm-6 col-lg-4"
											/>
											<SelectInput
												label="Cidade"
												id="id_cidade"
												labelSelect="nome"
												control={control}
												errors={errors}
												data={citiesData}
												setValue={setValue}
												onKeyDown={libForm.EnterTab}
												loading={loadingCities}
												className="col-12 col-sm-6 col-lg-4"
											/>

											<div className="input-select-box d-flex flex-column col-12 col-sm-6 col-lg-4">
												<label htmlFor="id_tipocolaborador">Tipo Colaborador</label>
												<select
													{...register("id_tipocolaborador", {
														setValueAs: (value) => parseInt(value, 10),
													})}
													defaultValue=""
													onChange={(e) => {
														// handleCategoryChange(e);
														register("id_tipocolaborador").onChange(e);
													}}
													onKeyDown={(e) => libForm.EnterTab(e)}
												>
													<option value="" disabled>
														Selecione um tipo
													</option>
													{collaboratorTypeData?.map((CollaboratorType) => (
														<option
															key={CollaboratorType.id_tipocolaborador}
															value={CollaboratorType.id_tipocolaborador}
														>
															{CollaboratorType.nome}
														</option>
													))}
												</select>
												{errors.id_tipocolaborador && (
													<p>{errors.id_tipocolaborador.message}</p>
												)}

												<div className="flex h-4 justify-end">
													<button
														type="button"
														className="flex btn btn-success items-center text-xs"
														onClick={handleOpenRegisterTypeCollaborator}
														onKeyDown={(e) => libForm.EnterTab(e)}
													>
														Cadastrar Tipo
													</button>
												</div>
											</div>

											<TextInput
												label="Cargo"
												id="tipo"
												placeholder=""
												register={register}
												errors={errors}
												onKeyDown={libForm.EnterTab}
												className="col-12 col-sm-4 col-lg-3"
											/>

											<div className="col-12 col-sm-6 col-lg-3 input-box">
												<label htmlFor="telefone_1">Celular</label>
												<input
													className={`${errors.telefone_1 ? "error" : ""}`}
													id="telefone_1"
													{...register("telefone_1")}
													type="text"
													placeholder="Celular"
													onKeyDown={(e) => libForm.EnterTab(e)}
													maxLength={14}
													autoComplete="off"
												/>
												{errors.telefone_1 && (
													<p className="errors">{errors.telefone_1.message}</p>
												)}
											</div>

											<div className="col-12 col-sm-6 col-lg-3 input-box">
												<label htmlFor="telefone_2">Telefone</label>
												<input
													className={`${errors.telefone_2 ? "error" : ""}`}
													id="telefone_2"
													{...register("telefone_2")}
													type="text"
													placeholder="Telefone"
													onKeyDown={(e) => libForm.EnterTab(e)}
													maxLength={14}
													autoComplete="off"
												/>
												{errors.telefone_2 && (
													<p className="errors">{errors.telefone_2.message}</p>
												)}
											</div>

											<div className="col-12 col-sm-6 col-lg-3 input-box">
												<label htmlFor="cpf">CPF/Cnpj</label>
												<input
													className={`${errors.cpf ? "error" : ""}`}
													id="cpf"
													{...register("cpf")}
													type="text"
													placeholder="Cpf"
													onKeyDown={(e) => libForm.EnterTab(e)}
													autoComplete="off"
												/>
												{errors.cpf && <p className="errors">{errors.cpf.message}</p>}
											</div>

											<div className="col-12 col-sm-6 col-lg-3 input-box">
												<label htmlFor="rg">RG</label>
												<input
													className={`${errors.rg ? "error" : ""}`}
													id="state"
													{...register("rg")}
													type="text"
													placeholder="Rg"
													onKeyDown={(e) => libForm.EnterTab(e)}
													autoComplete="off"
												/>
												{errors.rg && <p className="errors">{errors.rg.message}</p>}
											</div>

											<div className="input-select-box d-flex flex-column col-12 col-sm-6 col-lg-3">
												<label htmlFor="">Sexo</label>
												<select
													{...register("sexo")}
													defaultValue=""
													onKeyDown={(e) => libForm.EnterTab(e)}
												>
													<option value="" disabled hidden>
														Selecione uma opção
													</option>
													<option value="MASCULINO">MASCULINO</option>
													<option value="FEMININO">FEMININO</option>
													<option value="NÃO INFORMADO">NÃO INFORMADO</option>
												</select>
												{errors.sexo && <p className="errors">{errors.sexo.message}</p>}
											</div>

											<div className="col-12 col-sm-12 col-lg-6">
												<TextInput
													label="E-mail de acesso ao site"
													id="email"
													placeholder="E-mail de acesso ao portal"
													register={register}
													errors={errors}
													onKeyDown={libForm.EnterTab}
													className=""
												/>

												{/* <div className="flex h-4 justify-end">
													<button
														type="button"
														className="flex btn btn-success items-center text-xs"
														onClick={onReceiveEmailPassword}
														onKeyDown={(e) => libForm.EnterTab(e)}
													>
														Validar E-mail para gerar senha de acesso.
													</button>
												</div> */}
											</div>
											<div className="col-12 col-sm-12 col-lg-6">
												<TextInput
													label="E-mail de contato "
													id="email_contato"
													placeholder="E-mail"
													register={register}
													errors={errors}
													onKeyDown={libForm.EnterTab}
													className=""
												/>

												{/* <div className="flex h-4 justify-end">
													<button
														type="button"
														className="flex btn btn-success items-center text-xs"
														onClick={onReceiveEmailPassword}
														onKeyDown={(e) => libForm.EnterTab(e)}
													>
														Validar E-mail para gerar senha de acesso.
													</button>
												</div> */}
											</div>
											<div className="col-12 col-sm-12 col-lg-6 input-box">
												<label htmlFor="obs">Observações</label>
												<input
													className={`${errors.obs ? "error" : ""}`}
													id="state"
													{...register("obs")}
													type="text"
													placeholder="obs"
													autoComplete="off"
												/>
												{errors.obs && <p className="errors">{errors.obs.message}</p>}
											</div>
										</div>
									</TabPanel>
									{podeGerenciarPermissoes && (
										<TabPanel value="1">
											{/* <PermissionUser modulo="cad_permissao" hasButton={false}> */}
											<session id="permissoes">
												{Object.entries(permissionsFields).map(([group, items]) => (
													<div key={group} className="mb-4">
														<div className="border-bottom">
															<span className="text-xl border-slate-400">
																{group.charAt(0).toUpperCase() + group.slice(1)}
															</span>
															<Switch
																onChange={(e) => handleToggleAll(group, e.target.checked)}
																inputProps={{ "aria-label": "controlled" }}
															/>
														</div>
														<div className="flex mt-2 row">
															{items.filter(campoLiberado).map(({ label, id }) => (
																<CheckboxInput
																	key={id}
																	label={label}
																	id={id}
																	register={register}
																	errors={errors}
																	className="col-12 col-sm-4 col-lg-3"
																/>
															))}
														</div>
													</div>
												))}
											</session>
											{/* </PermissionUser> */}
										</TabPanel>
									)}
								</main>
							</TabContext>
							<footer>
								<BtnBack onClick={handleCloseModal} isSubmitting={isSubmitting} />

								<BtnSubmit isSubmitting={isSubmitting} />
							</footer>
						</form>
					)}
				</div>
			</Modal>
			<ModalMain ident={options.ident}>
				<HeaderRegister title="Tipo de Colaborador" subTitle="Cadastro de tipo de colaborador" />
				<Form
					idTable={0}
					selectedData={[]}
					reloadData={handleCloseModalTypeCollaborator}
					insert={insertCollaboratorType}
					ident={options.ident}
				/>
			</ModalMain>
		</>
	);
};
